

import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  toTop: {
    //  marginTop: 30,
    zIndex: 2,
    position: "fixed",
    bottom: "2vh",
    backgroundColor: "#DCDCDC",
    color: "black",
    "&:hover, &.Mui-focusVisible": {
      transition: "0.3s",
      color: "#397BA6",
      backgroundColor: "#DCDCDC",
    },
    [theme.breakpoints.up("xs")]: {
      right: "5%",
      backgroundColor: "rgb(220,220,220,0.7)",
    },
    [theme.breakpoints.up("lg")]: {
      right: "6.5%",
    },
  },
}));

// const ScrollToTop = (showBelow) => {

//   const classes = useStyles();

//   const [show, setShow] = useState(showBelow ? false : true);

//   const handleScroll = () => {
//     if (window.pageYOffset > showBelow) {
//       if (!show) setShow(true);
//     } else {
//       if (show) setShow(false);
//     }
//   };

//   const handleClick = () => {
//     window[`scrollTo`]({ top: 0, behavior: `smooth` });
//   };

//   useEffect(() => {
//     if (showBelow) {
//       window.addEventListener(`scroll`, handleScroll);
//       return () => window.removeEventListener(`scroll`, handleScroll);
//     }
//   });
//   return (
    // <div>
      
    //     <IconButton
    //       onClick={handleClick}
    //      className={classes.toTop}
    //       aria-label="to top"
    //       component="span"
    //      // size="medium"
    //     >
    //       <ExpandLessIcon />
    //     </IconButton>
   
    // </div>
//   );
// };



  
const ScrollToTop = () =>{
  const classes = useStyles();
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    // <Button>
    //  <FaArrowCircleUp onClick={scrollToTop} 
    //  style={{display: visible ? 'inline' : 'none'}} />
    // </Button>
    <div>
      
    <IconButton
      onClick={scrollToTop}
     className={classes.toTop}
      aria-label="to top"
      component="span"
      style={{display: visible ? 'inline' : 'none'}}
      size="medium"
    >
      <ExpandLessIcon />
    </IconButton>

</div>
  );
}

export default ScrollToTop;
